// Landing route for each role after login.
export const roleHomePath: Record<string, string> = {
  DOCTOR: '/doctor',
  PHARMACIST: '/pharmacist',
  PATIENT: '/patient',
  ADMIN: '/admin',
  AUDITOR: '/admin',
};

export function homePathFor(role?: string | null): string {
  return (role && roleHomePath[role]) || '/login';
}
